import { ModuleApprovalsRedirect } from '@/modules/approvals/ModuleApprovalsRedirect';

/** @deprecated Use global inbox at /work/approvals */
export function HrApprovalsPage() {
  return <ModuleApprovalsRedirect ownerModule="HR" />;
}
